import Layout from "./components/Layout";
import Chat from "../Tools/Chat";
import { useContext, useEffect } from "react";
import UserContext from "../../services/Context/UserContext";
import { useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { Button, Stack, TextField, Typography } from "@mui/material";
import API from "../../services/API";
import Loader from "../Tools/Loader";

export default function DpcPending(){

    const { id } = useParams()

    const { user } = useContext(UserContext)

    const [status, setStatus] = useState('loading')

    const [email, setEmail] = useState('');

    useEffect(() => {
        
        setEmail(user?.email || '');

    }, [user])

    useEffect(() => {
        if (id === 'cone-beam') {
            window.location.href = 'https://share-eu1.hsforms.com/1P-WL3_ecRNGNA9-nFlcTnA2dm850';
        } else {
            setStatus('ready');
        }
    }, [id]);

    const handleSubmit = e => {
        e.preventDefault();
        API.post('/contacts', { email: email, courseId: id });
        setStatus('success');
    }

    if (status === 'loading') {
        return <Loader />;
    }


    if(status === 'success') {
        return <Navigate to="/" />
    } 

    return (
        <Layout center>

            <form onSubmit={handleSubmit}>

                <Stack spacing={3} sx={{maxWidth: 500, margin: 'auto'}}>

                    <Typography variant="h1">Pré-inscription DPC</Typography>

                    <Typography>
                        Votre formation sera disponible prochainement. Pour recevoir une notification dès sa mise en ligne, merci de nous laisser votre adresse e-mail.
                    </Typography>

                    <TextField 
                        type="email"
                        name="email"
                        label="Adresse email"
                        value={email}
                        onChange={e => setEmail(e.target.value?.toLowerCase())}
                        required
                    />

                    <Button type="submit" variant="contained">
                        Valider
                    </Button>

                </Stack>

            </form>

            <Chat />

        </Layout>
    );
}
